import { Button } from "primereact/button";
import React, { useEffect, useState, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
// import AddEditUser from "./AddEditUser";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { toast } from "react-toastify";
import { Dropdown } from "primereact/dropdown";
import { Formik, useFormik } from "formik";
import * as Yup from "yup";
import classNames from "classnames";
import { useSelector } from "react-redux";
import axios from "axios";
import appUrl from "../../../config/appUrl";
import AddEditPrice from "./AddEditPrice";
const PriceConfig = () => {
     const [priceList, setPriceList] = useState([]);
 const [selectedSite, setSelectedSite] = useState(null);
  const [loading, setLoading] = useState(true);
const [displayDialog, setDisplayDialog] = useState(false);
const [selectedPrice, setSelectedPrice] = useState(null); // 👈 new
    const [categoryOptions, setCategoryOptions] = useState([]);
const [priceTypeOptions, setPriceTypeOptions] = useState([]);
const [selectedVehicleType, setSelectedVehicleType] = useState(null);
const [selectedPriceType, setSelectedPriceType] = useState(null);
const [filteredList, setFilteredList] = useState([]);
const [searchTerm, setSearchTerm] = useState("");

const [totalRecords, setTotalRecords] = useState(0);
const [first, setFirst] = useState(0);
const [rows, setRows] = useState(10);
const [currentPage, setCurrentPage] = useState(1);
 const handleDialog = async (price = null) => {
  if (price) {
    try {
      const response = await axios.get(
        `${appUrl.BASE_URL}PriceSetup/getById?priceSetupId=${price.id}`
      );

      if (response.data?.data) {
        setSelectedPrice(response.data.data); // 👈 full detailed record
        setDisplayDialog(true);
      } else {
        toast.error("Failed to load full price setup data");
      }
    } catch (error) {
      console.error("Error fetching price setup details:", error);
      toast.error("Error fetching price setup details");
    }
  } else {
    // 👇 For Add New
    setSelectedPrice(null);
    setDisplayDialog(true);
  }
};
    const onHide = (name) => {
    setDisplayDialog(false);
     setSelectedPrice(null);
  };

const getPriceList = async (page = 1, pageSize = 10) => {
  setLoading(true);
  try {
    // Build correct query params as per backend expectations
    const params = new URLSearchParams();

    params.append("page", page);
    params.append("pageSize", pageSize);
    params.append("isActive", true); // default true

    if (selectedVehicleType) params.append("vehicleType", selectedVehicleType);
    if (selectedPriceType) params.append("priceType", selectedPriceType);
    if (searchTerm) params.append("name", searchTerm); // ✅ correct key name is 'name'

    const response = await fetch(
      `${appUrl.BASE_URL}PriceSetup/all?${params.toString()}`
    );
    const data = await response.json();
    console.log("✅ Price List Response:", data);

    if (data?.data) {
      setPriceList(data.data);
      setTotalRecords(data.totalRecords || 0);
      setCurrentPage(data.currentPage || 1);
    } else {
      setPriceList([]);
      setTotalRecords(0);
    }
  } catch (error) {
    console.error("Error fetching price list:", error);
  } finally {
    setLoading(false);
  }
};

// ✅ Initial Load
useEffect(() => {
  getVehicleTypes();
  getPriceTypes();
  getPriceList(1, rows);
}, []);

// ✅ Pagination
const onPage = (event) => {
  const newPage = event.page + 1;
  setFirst(event.first);
  setRows(event.rows);
  getPriceList(newPage, event.rows);
};

useEffect(() => {
  getPriceList(1, rows);
}, [selectedVehicleType, selectedPriceType, searchTerm]);

const getVehicleTypes = async () => {
  try {
    const response = await fetch(`${appUrl.BASE_URL}category`);
    const data = await response.json();

    setCategoryOptions(data);
  } catch (error) {
    console.error(error);
  }
};

    // ✅ Fetch Price Types
    const getPriceTypes = async () => {
        try {
        const response = await fetch(`${appUrl.BASE_URL}PriceSetup/getPriceTypes`);
        const result = await response.json();
      
        setPriceTypeOptions(result);
        } catch (error) {
        console.error(error);
        }
    };

    useEffect(() => {
        getVehicleTypes();
        getPriceTypes();
    }, []);
      const actionBodyTemplate = (rowData) => {
    return (
      <Button
              icon="pi pi-user-edit"
           className="p-button-rounded p-button-text"
        onClick={() => handleDialog(rowData)}
        tooltip="Edit"
      />
    );
  };

  return (
     <>
           <Dialog
        draggable={false}
        visible={displayDialog}
        style={{ width: "55vw" }}
        onHide={() => onHide("displayDialog")}
      >
      
        <AddEditPrice
     
          onHide={onHide}
          getPriceList={getPriceList}
           editData={selectedPrice}
       
        
        />   
      </Dialog>

     <div>
           <div className="p-fluid grid align-items-center">
             <div className="col-12 md:col-4">
                 <div className="flex align-items-center">
                 <h5
                     className="mt-0 text-2xl mb-0 font-semibold text-[#17171B]"
                     style={{ color: "#17171B" }}
                   >
                     Price Configuration
                   </h5>
                 </div>
               </div>
               <div className="col-12 md:col-2">
  <input
    type="text"
    value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value)}
    placeholder="Search by name"
    className="p-inputtext p-component w-full"
  />
</div>
       <div className="col-12 md:col-2">
  <Dropdown
    value={selectedVehicleType}
    onChange={(e) => setSelectedVehicleType(e.value)}
    options={categoryOptions}
    optionLabel="name"
    optionValue="_id"
    placeholder="Select Vehicle Type"
    showClear
    className="w-full"
  />
</div>

{/* Price Type Filter */}
<div className="col-12 md:col-2">
  <Dropdown
    value={selectedPriceType}
    onChange={(e) => setSelectedPriceType(e.value)}
    options={priceTypeOptions}
    optionLabel="name"
    optionValue="id"
    placeholder="Select Price Type"
    showClear
    className="w-full"
  />
</div>
               <div className="col-12 md:col-2 text-right">
                 <Button
                   label="Add New"
                   className="Add__New-Button"
                   aria-label="Add User"
                   onClick={() => {
                     handleDialog();
                    //  setAddEditSite(false);
                   }}
                   icon="pi pi-plus"
                   iconPos="left"
                 />
               </div>
     
             </div>
           </div>
        <div className="card custom_card p-datatable-sm">
    <DataTable
  value={priceList}
  lazy
  paginator
  loading={loading}
  totalRecords={totalRecords}
  first={first}
  rows={rows}
  onPage={onPage}
  paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
  currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
  rowsPerPageOptions={[10, 20, 30, 50, 100]}
  stripedRows
  responsiveLayout="scroll"
>
                 
               <Column field="name" header="Name"></Column>
               <Column field="vehicleType" header="Vehicle Type"></Column>
               <Column field="priceType" header="Price Type"></Column>
     
               <Column body={actionBodyTemplate} header="Action" />
             </DataTable>
           </div>
     </>
  )
}

export default PriceConfig